<template>
    <div class="absolute">Circulo</div>
</template>

<script>
export default {}
</script>

<style></style>
